/** ファイル区分 */
class FileType {
  /** zipファイル */
  static ZIP = { name: '.zip', regex: /^application\/.*zip.*/ };
  /** 画像ファイル(jpg, png) */
  static IMAGE = { name: '.jpg、.pngのいずれかの', regex: /^image\/(png|jpeg)/ };
}

module.exports = FileType;